import { render, staticRenderFns } from "./overview.vue?vue&type=template&id=2a631a50&scoped=true&"
import script from "./overview.vue?vue&type=script&lang=js&"
export * from "./overview.vue?vue&type=script&lang=js&"
import style0 from "./overview.vue?vue&type=style&index=0&id=2a631a50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a631a50",
  null
  
)

export default component.exports